import { MarketEditService } from "./marketEditService";
import { angularServicesNames } from "@topline/services/angularServicesNames";

(function (module) {
    module.service("marketFinishValidationService", [
        MarketEditService.componentName,
        "modalService",
        "$q",
        angularServicesNames.$uibModal,
        angularServicesNames.$translate,
        marketFinishValidationService
    ]);

    function marketFinishValidationService(
        this: $TSFixMe,
        marketEditService: MarketEditService,
        modalService: $TSFixMe,
        $q: ng.IQService,
        $uibModal: ng.ui.bootstrap.IModalService,
        $translate: ng.translate.ITranslateService
    ) {
        var service = this;

        service.validateAndFinish = (markets: $TSFixMe) => {
            const defer = $q.defer();
            if (markets.length > 0) {
                marketEditService.validateToggleMarketsFinished(markets).then((validationResult: $TSFixMe) => {
                    if (validationResult.isValid) {
                        toggleFinish(markets, defer);
                    } else {
                        const modalInstance = $uibModal.open({
                            component: "marketFinishValidation",
                            windowClass: "wider-modal-window",
                            animation: true,
                            backdrop: "static",
                            resolve: {
                                markets: () => markets,
                                validationResult: () => validationResult
                            }
                        });

                        modalInstance.result.then(
                            () => marketEditService.toogleMarketsFinished(markets, true).then(() => defer.resolve()),
                            () => defer.reject()
                        );
                    }
                });
            } else {
                // @ts-expect-error ts-migrate(2304) FIXME: Cannot find name 'AlertService'.
                AlertService.warning($translate.instant("MARKET.NO_SELECTED_MARKETS_MEET_CRITERIA"));
                defer.reject();
            }
            return defer.promise;
        };

        function toggleFinish(markets: $TSFixMe, defer: $TSFixMe) {
            modalService.showConfirmationModal(
                {
                    text: "MARKET.SET_MARKETS_FINISHED_STATUS_CONFIRM",
                    title: "MARKET.SET_MARKETS_FINISHED_STATUS_CONFIRM_TITLE"
                },
                () => marketEditService.toogleMarketsFinished(markets, true).then(() => defer.resolve()),
                () => defer.reject()
            );
        }
    }
})(angular.module("topline.modules"));
